// SHI v29 - AUTO-SWITCH SKU + STATIC FRAME
(function(){'use strict';
var T=[
  {max:50,    id:'51927618748548', price:'0.99'},
  {max:100,   id:'51927618781316', price:'1.99'},
  {max:180,   id:'51927618814084', price:'2.35'},
  {max:250,   id:'51927618846852', price:'3.99'},
  {max:400,   id:'51927618879620', price:'4.99'},
  {max:600,   id:'51927618912388', price:'6.99'},
  {max:800,   id:'51927618945156', price:'9.99'},
  {max:1000,  id:'51927618977924', price:'12.99'},
  {max:1500,  id:'51927619010692', price:'14.99'},
  {max:Infinity, id:'51927619043460', price:'19.99'}
];
var A=['51927618748548','51927618781316','51927618814084','51927618846852','51927618879620','51927618912388','51927618945156','51927618977924','51927619010692','51927619043460'];
var _t=T[0],_h=false,_u=false,_q=500,_cur=null;
function gt(t){for(var i=0;i<T.length;i++)if(t<=T[i].max)return T[i];return T[T.length-1];}
function aj(u,o){return new Promise(function(r,s){var x=new XMLHttpRequest();x.open(o.method||'GET',u,true);if(o.contentType)x.setRequestHeader('Content-Type',o.contentType);x.onload=function(){r(x)};x.onerror=function(){s(x)};if(o.body)x.send(o.body);else x.send();});}
function fc(){return aj('/cart.js',{method:'GET'}).then(function(x){return x.status===200?JSON.parse(x.responseText):{total_price:0,item_count:0,items:[]};});}
function bc(){
  var s=['#checkout','[name="checkout"]','.cart__checkout-button','#CartDrawer-Checkout','.cart-summary button[type="submit"]','.cart__ctas button[type="submit"]','button[name="checkout"]','.cart-drawer__summary button[type="submit"]'];
  for(var i=0;i<s.length;i++){var e=document.querySelectorAll(s[i]);if(e.length>0)return e;}
  var all=document.querySelectorAll('a[href*="/checkout"],button[formaction*="/checkout"]');
  return all.length>0?all:null;
}
// Inject CSS once
if(!document.getElementById('sss')){
  var ss=document.createElement('style');ss.id='sss';
  ss.textContent='#sr{font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif;font-size:13px;color:#111;padding:4px 16px 8px;background:#fff;border-top:1px solid #e5e7eb;display:none;}#sr .r{display:flex;align-items:center;justify-content:space-between;padding:3px 0;}#sr .l{display:flex;align-items:center;gap:6px;}#sr .i{width:15px;height:15px;}#sr .i svg{width:15px;height:15px;display:block;}#sr .lb{font-size:13px;font-weight:500;}#sr .ib{background:none;border:none;padding:0;cursor:pointer;margin-left:2px;}#sr .ib svg{width:14px;height:14px;display:block;color:#9ca3af;}#sr .pr{font-size:13px;font-weight:600;}#sr .d{font-size:11px;color:#6b7280;margin:0 0 4px;}#sk{font-size:11px;color:#6b7280;text-align:center;padding:4px 0 6px;cursor:pointer;text-decoration:underline;display:none;}#sk:hover{color:#111;}';
  document.head.appendChild(ss);
}
var FW=false;
function cf(){
  if(FW||document.getElementById('sr'))return;
  var w=document.createElement('div');w.id='sr';
  w.innerHTML='<div class="r"><div class="l"><span class="i"><svg viewBox="0 0 15 16" width="15" height="16"><path d="M0 0h15v16H0z"/><g fill="#000" fill-rule="nonzero" transform="translate(2 2.5)"><path d="M0 0h11v11H0z" opacity="0"/><path d="M10.329 1.801L5.86.134A.86.86 0 005.5.07a.86.86 0 00-.362.066L.668 1.81A.976.976 0 000 2.776v4.652c0 .38.208.73.544.91l4.486 2.409c.152.082.32.123.488.123.158 0 .316-.037.46-.109l4.452-2.226A.975.975 0 0010.5 7.613V2.768a.975.975 0 00-.671-.967zM5.38.778c.039-.014.08-.021.12-.021s.082.007.12.021l3.928 1.465c.113.042.112.202-.001.242L8.294 2.93a.083.083 0 01-.124-.003L4.216 1.29c-.037-.015-.036-.067.001-.08zM5.156 9.603c0 .195-.208.319-.38.227L.87 7.732A.327.327 0 01.687 7.43V3.31c0-.178.176-.303.345-.243l3.782 1.35c.205.073.343.268.343.486v4.702zm-.003-5.796L1.464 2.49c-.113-.041-.115-.2-.002-.242l1.646-.618c.04-.015.086-.015.125.002l3.929 1.625c.036.015.035.067-.002.08l-1.314.47a.935.935 0 01-.693 0zm5.16 3.805c0 .131-.073.25-.19.307l-3.906 1.953c-.171.086-.373-.039-.373-.231V5.702c0-.218.138-.412.343-.486l1.491-.533c.028-.01.057.01.057.041v2.124c0 .063.068.105.125.077l.468-.234a.155.155 0 00.095-.154V5.54c0-.073.046-.137.114-.162l1.432-.511c.167-.06.344.064.344.243z"/></g></svg></span><span class="lb">Shipping Protection</span><button class="ib"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg></button></div><span class="pr" id="pr">$0.00</span></div><div class="d">Quick refund for lost, damaged or delayed package.</div>';
  w.querySelector('.ib').onclick=function(){
    var m=document.createElement('div');m.style.cssText='position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.45);z-index:999999;display:flex;align-items:center;justify-content:center;padding:20px;';
    m.innerHTML='<div style="background:#fff;border-radius:16px;padding:24px;max-width:380px;width:100%;position:relative;box-shadow:0 20px 60px rgba(0,0,0,0.15);"><button class="c" style="position:absolute;top:12px;right:16px;background:none;border:none;font-size:24px;color:#9ca3af;cursor:pointer;padding:0;">&times;</button><h3 style="font-size:18px;font-weight:700;margin:0 0 12px;">&#x1F6E1;&#xFE0F; Shipping Protection</h3><div style="font-size:14px;color:#374151;line-height:1.6;"><p><strong>What is Shipping Protection?</strong></p><p>Shipping Protection covers your order in case it gets lost, damaged, or delayed during transit.</p><p><strong>Cost:</strong> $'+_t.price+'</p></div></div>';m.onclick=function(e){if(e.target===m||e.target.className==='c')m.remove();};document.body.appendChild(m);
  };
  var sk=document.createElement('div');sk.id='sk';sk.textContent='Checkout without shipping protection';sk.onclick=function(){window.location.href='/checkout';};
  var cb=bc();
  if(cb&&cb[0]){
    var btn=cb[0];
    var parent=btn.parentNode;
    var gp=parent.parentNode;
    parent.insertBefore(w,btn);
    parent.insertBefore(sk,w.nextSibling);
    if(gp&&gp.nodeType===1){
      var pstyle=window.getComputedStyle(parent);
      if(pstyle.display==='flex'||pstyle.display==='inline-flex'){
        gp.insertBefore(w,parent);
        gp.insertBefore(sk,w.nextSibling);
      }
    }
  } else {document.body.appendChild(w);document.body.appendChild(sk);}
  FW=true;
}
function tk(){
  if(_u)return;_u=true;
  fc().then(function(c){
    _h=c.item_count>0;
    if(!document.getElementById('sr')){cf();}
    var w=document.getElementById('sr');var sk=document.getElementById('sk');
    if(!w||!sk){_u=false;return;}
    w.style.display=_h?'block':'none';sk.style.display=_h?'block':'none';
    if(_h){
      var total=c.total_price/100;
      var t=gt(total);_t=t;
      var pr=document.getElementById('pr');if(pr)pr.textContent='$'+t.price;
      // Auto-switch: 如果档位变了，替换购物车里的保险 SKU
      if(_cur!==t.id){
        // 1. 找出购物车里已有的保险
        var oldIns=null;
        for(var i=0;i<c.items.length;i++){
          if(A.indexOf(String(c.items[i].variant_id))!==-1){oldIns=c.items[i].variant_id;break;}
        }
        // 2. 如果有旧保险但档位变了，移除旧保险
        if(oldIns&&String(oldIns)!==String(t.id)){
          aj('/cart/change.js',{method:'POST',contentType:'application/json',body:JSON.stringify({id:oldIns,quantity:0})});
        }
        // 3. 如果没有保险，加新保险
        if(!oldIns){
          aj('/cart/add.js',{method:'POST',contentType:'application/json',body:JSON.stringify({id:t.id,quantity:1})});
        }
        _cur=t.id;
      }
      // 4. 更新按钮文字
      var btns=bc();
      if(btns)btns.forEach(function(b){
        if(!b.getAttribute('d'))b.setAttribute('d',b.textContent.trim()||'Check out');
        b.textContent=b.getAttribute('d')+(_h?' + $'+t.price:'');
        if(!b._b){
          b._b=true;
          b.addEventListener('click',function(e){
            if(!_h)return;
            e.preventDefault();
            this.disabled=true;
            // 确保保险已添加
            fc().then(function(c){
              var total=c.total_price/100;
              var t=gt(total);
              var hasIns=false;
              for(var i=0;i<c.items.length;i++){
                if(A.indexOf(String(c.items[i].variant_id))!==-1){hasIns=true;break;}
              }
              if(!hasIns){
                aj('/cart/add.js',{method:'POST',contentType:'application/json',body:JSON.stringify({id:t.id,quantity:1})}).then(function(){
                  window.location.href='/checkout';
                }).catch(function(){
                  window.location.href='/checkout';
                });
              } else {
                window.location.href='/checkout';
              }
            });
          });
        }
      });
    } else {
      _cur=null;
      var btns=bc();
      if(btns)btns.forEach(function(b){var d=b.getAttribute('d');if(d)b.textContent=d;});
    }
  }).catch(function(){}).then(function(){_u=false;});
}
function init(){
  if(window.location.pathname.indexOf('/checkout')===0||window.location.pathname.indexOf('/orders/')===0)return;
  cf();
  fc().then(function(c){for(var i=0;i<c.items.length;i++){if(A.indexOf(String(c.items[i].variant_id))!==-1){aj('/cart/change.js',{method:'POST',contentType:'application/json',body:JSON.stringify({id:c.items[i].variant_id,quantity:0})});if(window.location.pathname.indexOf('/cart')===-1)window.location.href='/cart';}}}).catch(function(){}).then(function(){tk();setInterval(tk,_q);});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();